import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-progress',
  templateUrl: './circle-progress.component.html',
  styleUrls: ['./circle-progress.component.css'],
})
export class CircleProgressComponent {
  @Input() progressValue!: number;

  getColor(): string {
    if (this.progressValue < 50) {
      return '#FF0000';
    } else if (this.progressValue >= 50 && this.progressValue < 65) {
      return '#FFA500';
    } else {
      return '#4CAF50';
    }
  }
}
